import React from "react";
import playIcon from "../assets/playbtn.png";
import "./playbtn.css";

const PlayBtn = () => {
  return (
    <button className="play-btn">
      <img src={playIcon}/>
    </button>
  );
};

export default PlayBtn;